export default __webpack_public_path__ + "static/media/followedIcon.918f9c52.svg";